import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import CKEditor from '@ckeditor/ckeditor5-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import "vue-wysiwyg/dist/vueWysiwyg.css"
import VueRouter from 'vue-router'
import VueAxios from 'vue-axios'
import axios from 'axios'
import VueSidebarMenu from 'vue-sidebar-menu'
import wysiwyg from "vue-wysiwyg"
import VueBootstrapTypeahead from './components/typeahead/VueBootstrapTypeahead.vue'
import VuePapeParse from 'vue-papa-parse'
import { VueSpinners } from '@saeris/vue-spinners'
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import underscore from 'vue-underscore'
import VueBootstrap4Table from 'vue-bootstrap4-table'
import VueMobileDetection from "vue-mobile-detection"
import InputTag from 'vue-input-tag'
import VCalendar from 'v-calendar'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/fr'

import store from './store/index'



Vue.use(Vuex)
Vue.use(Element, {locale})
Vue.use(VueSidebarMenu)
Vue.use(BootstrapVue)
Vue.use(VueRouter)
Vue.use(VueAxios, axios)
Vue.use(wysiwyg, {hideModules: { "image": true, "unorderedList": true,"orderedList": true,"code": true,"link": true,"headings": true,"table": true,"removeFormat": true,"separator": true}})
Vue.use(CKEditor)
Vue.use(VuePapeParse)
Vue.use(VueSpinners)
Vue.component('vue-phone-number-input', VuePhoneNumberInput)
Vue.use(underscore)
Vue.component('vue-bootstrap4-table', VueBootstrap4Table)
Vue.use(VueMobileDetection)
Vue.component('input-tag', InputTag)
Vue.use(VCalendar)
Vue.use(require('vue-moment'))


Vue.config.productionTip = false
Vue.config.performance = true


import Login from './components/Login.vue'
import Inscription from './components/Inscription.vue'
import Index from './components/Index.vue'
import ChangePassOublie from './components/ChangePassOublie.vue'
import PremiereConnexion from './components/PremiereConnexion.vue'
import CreateAccountForm from './components/CreateAccountForm.vue'
import AjoutTiers from './components/modules/tiers/AjoutTiers.vue'

import IndexClient from './components/modules/extranet/IndexClient.vue'
import Contenu from './components/modules/extranet/Contenu.vue'
import ContenuProfil from './components/modules/extranet/ContenuProfil.vue'
import MesDocuments from './components/modules/extranet/MesDocuments.vue'
import Assistance from './components/modules/ticketSup/Assistance.vue'
import AideClient from './components/modules/extranet/AideClient.vue'
import ProfilClient from './components/modules/extranet/ProfilClient.vue'
import InfoSoc from './components/modules/extranet/InfoSoc.vue'
import ChangePass from './components/modules/extranet/ChangePass.vue'
// import CommandeDomaine from './components/modules/extranet/CommandeDomaine.vue'
// import CommandeMailboxes from './components/modules/extranet/CommandeMailboxes.vue'
// import NosOffres from './components/modules/extranet/NosOffres.vue'

import IndexAdmin from './components/routes/IndexAdmin.vue'
import Tiers from './components/modules/tiers/Tiers.vue'
import DetailsTiers from './components/modules/tiers/DetailsTiers.vue'
import CreationDevis from './components/modules/tiers/devisFactures/CreationDevis.vue'
import EditionDevis from './components/modules/tiers/devisFactures/EditionDevis.vue'
import ContenuAdmin from './components/routes/ContenuAdmin.vue'
import ContenuExterne from './components/routes/ContenuExterne.vue'
import SuiviTicketAdmin from './components/modules/ticketSup/SuiviTicketAdmin.vue'
import CreationTicketAdmin from './components/modules/ticketSup/CreationTicketAdmin.vue'
import AideAdmin from './components/routes/AideAdmin.vue'
import GestionTemplates from './components/routes/GestionTemplates.vue'
import GestionCarroussel from './components/routes/GestionCarroussel.vue'
import GestionCommandeDomaine from './components/routes/GestionCommandeDomaine.vue'
import ConfirmationInscription from './components/routes/ConfirmationInscription.vue'
import ExportVenteJePilote from './components/modules/comptabilite/exportJePilote/ExportVenteJePilote.vue'
import ExportPrelevementJePilote from './components/modules/comptabilite/exportJePilote/ExportPrelevementJePilote.vue'
import Facturation from './components/modules/comptabilite/facturation/Facturation.vue'
import ContratDeService from './components/modules/contratDeService/ContratDeService.vue'
import Fournisseur from './components/modules/fournisseur/Fournisseur.vue'
import BonDeLivraison from './components/modules/outils/livraison/BonDeLivraison.vue'
import StatsAppelsEntrant from './components/modules/outils/telephonie/StatsAppelsEntrant.vue'
import ContactVcf from './components/modules/outils/vcf/ContactVcf.vue'
import Prospection from './components/modules/outils/prospection/Prospection.vue'
import ecommerce from './components/modules/e-commerce/e-commerce.vue'
import detailsProduct from './components/modules/e-commerce/details-product/details-product.vue'
import catalogue from './components/modules/catalogue/Catalogue.vue'
import DocumentsLegaux from './components/modules/documentsLegaux/DocumentsLegaux.vue'
import NotesDeFrais from './components/modules/notesDeFrais/NotesDeFrais.vue'

import VisioClient from './components/routes/VisioClient.vue'
import VisioMiddleware from './components/routes/VisioMiddleware.vue'
 
import Error403 from './components/403.vue'
import Error404 from './components/404.vue'

//LDAP
import GestionUser from './components/modules/outils/ldap/GestionUser.vue'
import CreateUser from './components/modules/outils/ldap/CreateUser.vue'
import UserDetails from './components/modules/outils/ldap/UserDetails.vue'
import EditUser from './components/modules/outils/ldap/EditUser.vue'
import ListGroup from './components/modules/outils/ldap/ListGroup.vue'
import CreateGroup from './components/modules/outils/ldap/CreateGroup.vue'
import GroupDetails from './components/modules/outils/ldap/GroupDetails.vue'

//Vue admin
Vue.component('index-admin-layout', IndexAdmin)
Vue.component('tiers-layout', Tiers)
Vue.component('details-tiers-layout', DetailsTiers)
Vue.component('creation-devis-layout', CreationDevis)
Vue.component('edition-devis-layout', EditionDevis)
Vue.component('suivi-ticket-admin-layout', SuiviTicketAdmin)
Vue.component('creation-ticket-admin-layout', CreationTicketAdmin)
Vue.component('aide-admin-layout', AideAdmin)
Vue.component('gestion-templates-layout', GestionTemplates)
Vue.component('gestion-carroussel-layout', GestionCarroussel)
Vue.component('export-vente-je-pilote-layout', ExportVenteJePilote)
Vue.component('export-prelevement-je-pilote-layout', ExportPrelevementJePilote)
Vue.component('facturation-layout', Facturation)
Vue.component('cds-layout', ContratDeService)
Vue.component('fournisseur-layout', Fournisseur)
Vue.component('bon-de-livraison-layout', BonDeLivraison)
Vue.component('stats-appels-entrant-layout', StatsAppelsEntrant)
Vue.component('contact-vcf-layout', ContactVcf)
Vue.component('prospection-layout', Prospection)
Vue.component('ajout-tiers', AjoutTiers)
Vue.component('catalogue-layout', catalogue)
Vue.component('notes-de-frais-layout', NotesDeFrais)

// LDAP layout
Vue.component('gestion-user-layout', GestionUser)
Vue.component('create-user-layout', CreateUser)
Vue.component('user-details-layout', UserDetails)
Vue.component('edit-user-layout', EditUser)
Vue.component('list-group-layout', ListGroup)
Vue.component('create-group-layout', CreateGroup)
Vue.component('group-details-layout', GroupDetails)
// Vue.component('gestion-commande-domaine-layout', GestionCommandeDomaine)

// Vue mixte
Vue.component('create-account-form', CreateAccountForm)

//Vue client
Vue.component('index-client-layout', IndexClient)
Vue.component('mes-documents-layout', MesDocuments)
Vue.component('suivi-ticket-client-layout', Assistance)
Vue.component('aide-client-layout', AideClient)
Vue.component('profil-client-layout', ProfilClient)
Vue.component('info-soc-client-layout', InfoSoc)
Vue.component('change-pass-client-layout', ChangePass)
// Vue.component('commande-domaine-client-layout', CommandeDomaine)
// Vue.component('commande-mailboxes-client-layout', CommandeMailboxes)
// Vue.component('nos-offres-client-layout', NosOffres)
Vue.component('confirmation-inscription-client-layout', ConfirmationInscription)
Vue.component('visio-client-layout', VisioClient)
Vue.component('e-commerce-layout', ecommerce)
Vue.component('details-product-layout', detailsProduct)
Vue.component('documents-legaux-layout', DocumentsLegaux)

//Composants perso.
Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead)

const routes = [
  // === Public / Auth ===
  { name: 'home', path: '/', component: Index },
  { name: 'login', path: '/login', component: Login },
  { name: 'inscription', path: '/inscription', component: Inscription },
  { name: 'changePassOublie', path: '/changePassOublie/:token', component: ChangePassOublie },
  { name: 'premiereConnexion', path: '/premiereConnexion/:token', component: PremiereConnexion },
  { name: 'ConfirmationInscription', path: '/ConfirmationInscription', component: ConfirmationInscription },

  // === Client / Extranet ===
  {
    name: 'indexClient',
    path: '/indexClient',
    component: Contenu,
    meta: { layout: "index-client" }
  },
  {
    name: 'mesDocuments',
    path: '/mesDocuments',
    component: Contenu,
    meta: { layout: "mes-documents" }
  },
  {
    name: 'assistance',
    path: '/assistance',
    component: Contenu,
    meta: { layout: "suivi-ticket-client" }
  },
  {
    name: 'aideClient',
    path: '/aideClient',
    component: Contenu,
    meta: { layout: "aide-client" }
  },
  {
    name: 'profilClient',
    path: '/profilClient',
    component: ContenuProfil,
    meta: { layout: "profil-client" }
  },
  {
    name: 'infoSoc',
    path: '/infoSoc',
    component: ContenuProfil,
    meta: { layout: "info-soc-client" }
  },
  {
    name: 'changePass',
    path: '/changePass',
    component: ContenuProfil,
    meta: { layout: "change-pass-client" }
  },

  // === Visio ===
  { name: 'Visio', path: '/Visio', component: Contenu, meta: { layout: "visio-client" } },
  { name: 'VisioMiddleware', path: '/Visio/:jwt', component: VisioMiddleware },

  // === Admin / Backoffice ===
  {
    name: 'indexAdmin',
    path: '/indexAdmin',
    component: ContenuAdmin,
    meta: { layout: "index-admin" }
  },
  { name: 'tiers', path: '/tiers', component: ContenuAdmin, meta: { layout: "tiers" } },
  { name: 'detailsTiers', path: '/detailsTiers/:id', component: ContenuAdmin, meta: { layout: "details-tiers" } },

  // Devis / Facturation (création & édition)
  { name: 'creationDevis', path: '/creationDevis', component: ContenuAdmin, meta: { layout: "creation-devis" } },
  { name: 'creationDevisWithId', path: '/creationDevis/:id', component: ContenuAdmin, meta: { layout: "creation-devis" } },
  { name: 'editionDevis', path: '/editionDevis/:idTiers/:idPropale', component: ContenuAdmin, meta: { layout: "edition-devis" } },

  // Tickets / Templates / Carroussel
  { name: 'suiviTicketAdmin', path: '/suiviTicketAdmin', component: ContenuAdmin, meta: { layout: "suivi-ticket-admin" } },
  { name: 'creationTicketAdmin', path: '/creationTicketAdmin', component: ContenuAdmin, meta: { layout: "creation-ticket-admin" } },
  { name: 'gestionTemplates', path: '/gestionTemplates', component: ContenuAdmin, meta: { layout: "gestion-templates" } },
  { name: 'gestionCarroussel', path: '/gestionCarroussel', component: ContenuAdmin, meta: { layout: "gestion-carroussel" } },

  // Comptabilité / Exports
  { name: 'exportVenteJePilote', path: '/comptabilite/exportVenteJePilote', component: ContenuAdmin, meta: { layout: "export-vente-je-pilote" } },
  { name: 'exportPrelevementJePilote', path: '/comptabilite/exportPrelevementJePilote', component: ContenuAdmin, meta: { layout: "export-prelevement-je-pilote" } },
  { name: 'facturation', path: '/comptabilite/facturation', component: ContenuAdmin, meta: { layout: "facturation" } },

  // Fournisseurs / Contrats / Catalogue
  { name: 'fournisseur', path: '/fournisseur', component: ContenuAdmin, meta: { layout: "fournisseur" } },
  { name: 'contratDeService', path: '/contratDeService', component: ContenuAdmin, meta: { layout: "cds" } },
  { name: 'gestionCommandeDomaine', path: '/gestionCommandeDomaine', component: ContenuAdmin, meta: { layout: "gestion-commande-domaine" } },
  { name: 'catalogue', path: '/catalogue', component: ContenuAdmin, meta: { layout: "catalogue" } },

  // Outils / Livraison / VCF / Prospection / Telephonie
  { name: 'BonDeLivraison', path: '/outils/livraison/bonDeLivraison', component: ContenuAdmin, meta: { layout: "bon-de-livraison" } },
  { name: 'ContactVcf', path: '/outils/vcf/contactVcf', component: ContenuAdmin, meta: { layout: "contact-vcf" } },
  { name: 'Prospection', path: '/outils/prospection', component: ContenuAdmin, meta: { layout: "prospection" } },
  { name: 'StatsAppelsEntrant', path: '/outils/telephonie/statsAppelsEntrant', component: ContenuAdmin, meta: { layout: "stats-appels-entrant" } },

  // Aide / Admin pages
  { name: 'aideAdmin', path: '/aideAdmin', component: ContenuAdmin, meta: { layout: "aide-admin" } },

  // === LDAP / User management ===
  { name: 'group-details', path: '/role/:cn/details', component: ContenuAdmin, meta: { layout: 'group-details' } },
  { name: 'create-group', path: '/create-role', component: ContenuAdmin, meta: { layout: 'create-group' } },
  { name: 'list-group', path: '/roles', component: ContenuAdmin, meta: { layout: 'list-group' } },

  { name: 'edit-user', path: '/user/:uid/edit', component: ContenuAdmin, meta: { layout: 'edit-user' } },
  { name: 'gestion-user', path: '/gestion-user', component: ContenuAdmin, meta: { layout: 'gestion-user' } },
  { name: 'create-user', path: '/create-user', component: ContenuAdmin, meta: { layout: 'create-user' } },

  // === E‑commerce / Products ===
  { name: 'e-commerce', path: '/e-commerce', component: Contenu, meta: { layout: "e-commerce" } },
  { name: 'details-product', path: '/product/:pid/details', component: Contenu, meta: { layout: "details-product" } },
  { name: 'documents-legaux', path: '/documentsLegaux/:source/:id/:securekey', component: ContenuExterne, meta: { layout: "documents-legaux" } },
  { name: 'details-product', path: '/product/:pid/details', component: Contenu, meta: { layout: "details-product" } },

  // Notes de frais, visio client, etc.
  { name: 'user-details', path: '/user/:uid/details', component: ContenuAdmin, meta: { layout: 'user-details' } },
  { name: 'NotesDeFrais', path: '/notes-de-frais', component: ContenuAdmin, meta: { layout: 'notes-de-frais' } },
  { name: 'VisioClient', path: '/visio-client', component: VisioClient, meta: {} },

  // === LDAP layouts mappings (routes that map to admin components) ===
  { path: '/outils/ldap/gestion-user', component: ContenuAdmin, meta: { layout: 'gestion-user' } },

  // === Error pages ===
  { name: 'error403', path: '/error403', component: Error403 },
  { path: '*', component: Error404 }
]

const router = new VueRouter({ mode: 'history', routes: routes})

// new Vue(Vue.util.extend({ router }, App)).$mount('#app')
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')